import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { exchangeSession } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const { setUser } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = location.hash || window.location.hash;
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            navigate("/", { replace: true });
            return;
        }

        (async () => {
            try {
                // Referral code captured on the landing page travels with the exchange.
                const ref = localStorage.getItem("nerdy_ref");
                const { data } = await exchangeSession(sessionId, ref);
                if (data?.user) setUser(data.user);
                localStorage.removeItem("nerdy_ref");
                // Return to where the user started (e.g. a /c/<id> challenge page).
                const dest = localStorage.getItem("nerdy_post_auth_path") || "/dashboard";
                localStorage.removeItem("nerdy_post_auth_path");
                window.history.replaceState(null, "", dest);
                navigate(dest, { replace: true, state: { user: data.user } });
            } catch (e) {
                navigate("/", { replace: true });
            }
        })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="min-h-screen flex items-center justify-center bg-black text-white" data-testid="auth-callback">
            <div className="text-center">
                <div className="label-tactical mb-2">Signing in</div>
                <div className="metric text-4xl">…</div>
            </div>
        </div>
    );
}
